import IconListContainer from "~/components/IconListContainer/IconListContainer";
import * as React from 'react';
export default {
  IconListContainer,
  React
};